import PageLayout from '../../common/components/PageLayout/PageLayout'
import './Collaborations.css'

function Collaborations () {
  return <PageLayout title="Collaboration">Collaboration</PageLayout>
}

export default Collaborations
